import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	issueError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueErrorIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issueError: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error',
		defaultMessage: 'We’re having trouble searching issues. You can try again in a few moments.',
		description: 'Error message if issue search fails',
	},
	issues: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues',
		defaultMessage: 'Issues',
		description: 'Section title for issues',
	},
	issueErrorIssueTermRefresh: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error-issue-term-refresh',
		defaultMessage:
			'We’re having trouble searching work items. You can try again in a few moments.',
		description: 'Error message if issue search fails',
	},
	issuesIssueTermRefresh: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues-issue-term-refresh',
		defaultMessage: 'Work items',
		description: 'Section title for issues',
	},
});
